import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSummaryData } from "../../../redux/slice/DashboardSlice/DashboardSlice";
import { Row, Col, Card } from "react-bootstrap";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

function StatCards({ endDate, startDate, search, setSearch, comp, jobSiteId }) {
  const { SummaryData } = useSelector((state) => state?.Dashboard);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (search && comp) {
      dispatch(
        fetchSummaryData({
          start: startDate,
          end: endDate,
          compId: comp,
          jobSite: jobSiteId,
        })
      );
      setSearch(false);
    }
  }, [dispatch, search, comp, startDate, endDate, jobSiteId, setSearch]);

  const cards = [
    {
      title: "Total",
      value: SummaryData?.data?.totalInspections,
      // bg: "#ECEAE2",
      bg: "#575975c7",
      border: "#ECEAE2",
    },
    {
      title: "Completed",
      value: SummaryData?.data?.Completed,
      // bg: "#C8E6C9",
      bg: "#575975c7",
      border: "#C8E6C9",
      route: "/package/completed",
    },
    {
      title: "Pending",
      value: SummaryData?.data?.Pending,
      // bg: "#FFEFD5",
      bg: "#575975c7",
      border: "#FFEFD5",
      route: "/package/pending",
    },
    {
      title: "InProgress",
      value: SummaryData?.data?.InProgress,
      // bg: "rgb(204, 235, 250)",
      bg: "#575975c7",
      border: "rgb(204, 235, 250)",
      route: "/package/in-progress",
    },
    {
      title: "Cancelled",
      value: SummaryData?.data?.Cancelled,
      // bg: "#FF6A6A",
      bg: "#575975c7",
      border: "#FF6A6A",
      route: "/package/cancelled",
    },
    {
      title: "On Hold",
      value: SummaryData?.data?.OnHold,
      // bg: "lightgrey",
      bg: "#575975c7",
      border: "lightgrey",
      route: "/package/on-hold",
    },
  ];

  return (
    <div className="mt-4 statcards-container">
      <Row className="justify-content-center g-3">
        {cards.map((card, idx) => (
          <Col
            key={idx}
            xs={12}
            sm={6}
            md={4}
            lg={3}
            xl={2}
            className="d-flex justify-content-center"
          >
            <Card
              style={{
                borderRadius: "0.75rem",
                // border: `1px solid ${card.border}`,
                backgroundColor: card.bg,
                cursor: card.route ? "pointer" : "default",
                color: "white"
              }}
              className="text-center stat-card"
              onClick={() =>
                card.route ? navigate(card.route, { state: { comp } }) : null
              }
            >
              <Card.Body>
                <Card.Title className="stat-title">{card.title}</Card.Title>
                <Card.Text className="stat-value">{card.value}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default StatCards;

StatCards.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  setSearch: PropTypes.func,
  search: PropTypes.bool,
  comp: PropTypes.string.isRequired,
  jobSiteId: PropTypes.string,
};
